<!--<h1 mat-dialog-title>Hi {{data.name}}</h1>-->

<ng-container *ngIf="SubmissionStatus$ | async as status">

    <div mat-dialog-content style="min-height:200px;">

        <div>
            <h4>Send a message to {{agentNameDisplay$ | async}}</h4>
        </div>

        <div class="Vert-15">

        </div>

        <div *ngIf="status == 'Sending'" class="Vert-30">
            <lgv-loading-indicator [CSSClass]="'Small'"></lgv-loading-indicator>
        </div>

        <div *ngIf="status == 'NA'">

            <mat-form-field appearance="outline" floatLabel="always" style="width:100%;">
                <mat-label>Message</mat-label>
                <textarea matInput [(ngModel)]="Message"
                          minlength="10" maxlength="1000" cdkTextareaAutosize
                          #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="4" cdkAutosizeMaxRows="10"></textarea>
            </mat-form-field>

        </div>

        <div class="col-12" *ngIf="status == 'Success'">
            <p>Your message was received.</p>
            <!-- <p>You will hear from us shortly.</p> -->
        </div>

        <div *ngIf="status == 'Error'">
            <p>There was an error processing your request.</p>
            <div class="col-12">
                <div class="Vert-20"></div>
                <button (click)="onReturnToClientHome()" class="btn btn-secondary">Return to Dashboard</button>
                <div class="Vert-20"></div>
            </div>
        </div>

    </div>

    <div mat-dialog-actions>
        <button mat-button (click)="onNoClick()">
            <span *ngIf="status == 'Success'">Close</span>
            <span *ngIf="status != 'Success'">Cancel</span>
        </button>
        <button type="button" class="btn btn-secondary formBtn" (click)="OnSendEmail()" *ngIf="status != 'Success'">Send</button>
    </div>

</ng-container>

